/**
 * @file warehouse-selector.tsx
 * @module app/modules/setting/components/warehouse-selector
 * @description Warehouse dropdown rendered next to non-global setting rows.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.5
 * @version 1.3.5
 */

import { Form } from 'react-bootstrap';
import type { WarehouseItem } from '../../../context/WarehouseContext';
import type { IFlagItem } from '../types/configurations.types';

interface IWarehouseSelectorProps {
  item: IFlagItem;
  value: string;
  disabled: boolean;
  warehouseList: WarehouseItem[];
  onChange: (item: IFlagItem, warehouseId: string) => void;
}

/**
 * Renders a warehouse selector for non-global setting rows.
 * @param {IWarehouseSelectorProps} props Selector props.
 * @returns {JSX.Element | null} Warehouse dropdown, or null for global settings.
 */
const WarehouseSelector = ({ item, value, disabled, warehouseList, onChange }: IWarehouseSelectorProps) => {
  if (item.isGlobal !== false) {
    return null;
  }

  return (
    <Form.Select
      className="setting-warehouse-select me-4"
      value={value || ''}
      disabled={disabled}
      onChange={(e) => onChange(item, e.target.value)}
    >
      {warehouseList.map((warehouse) => (
        <option key={warehouse.value} value={warehouse.value}>
          {warehouse.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default WarehouseSelector;
